function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import cn from 'classnames';
import { EXPAND_ICON_POSITION } from 'swag-client-common/constants';
import { PRODUCT_BUILDER_MODES } from 'swag-client-common/utils/constants';
import Drawer from '../../ui/drawer';
import classes from './related-products-popup.scss';
import { Products } from './components/products';
import ProductEditor from './components/product-editor';
import { Details } from './components/details';
import ProductPreviews from './components/product-previews';
const POPUP_STATUSES = {
  minimize: 'minimize',
  maximize: 'maximize'
};
const TRANSITION_TIME = 400;
const closeButtonStyles = {
  top: '11px',
  right: '15px',
  left: 'initial',
  bottom: 'initial'
};
const Text1 = ({
  className
}) => /*#__PURE__*/React.createElement("p", {
  className: className
}, "Your logo will be in the same position as the main product.");
const Text2 = ({
  className
}) => /*#__PURE__*/React.createElement("p", {
  className: className
}, "We'll send you a production mockup for approval before printing.");
const HeaderContent = ({
  isExpand
}) => /*#__PURE__*/React.createElement("div", {
  className: cn(classes.headerContent, {
    [classes.minimize]: !isExpand
  })
}, /*#__PURE__*/React.createElement("div", {
  className: cn(classes.infoBlock, {
    [classes.minimize]: !isExpand
  })
}, /*#__PURE__*/React.createElement("span", {
  className: cn(classes.infoIcon, {
    [classes.minimize]: !isExpand
  })
}, "i"), isExpand && /*#__PURE__*/React.createElement("div", {
  className: classes.textWrapper
}, /*#__PURE__*/React.createElement(Text1, {
  className: classes.expandedText
})), /*#__PURE__*/React.createElement("div", {
  className: classes.tooltipWrapper
}, /*#__PURE__*/React.createElement(Text1, {
  className: classes.text
}), /*#__PURE__*/React.createElement(Text2, {
  className: classes.text
}))));
const initialState = {
  previousStatus: POPUP_STATUSES.minimize,
  expandIconPosition: EXPAND_ICON_POSITION.up,
  isExpand: false,
  isBuilderOpen: false,
  chosenProduct: null
};
export class RelatedProductsPopupComponent extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      open,
      popupMode
    } = nextProps;
    if (open && popupMode === PRODUCT_BUILDER_MODES.REBUILD_MODE) {
      return _objectSpread({}, prevState, {
        isExpand: true,
        isBuilderOpen: true,
        EXPAND_ICON_POSITION: EXPAND_ICON_POSITION.left
      });
    }
    return null;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "expandClickHandler", () => {
      const {
        isBuilderOpen,
        previousStatus
      } = this.state;
      switch (true) {
        case isBuilderOpen && previousStatus === POPUP_STATUSES.minimize:
          this.setState({
            isBuilderOpen: false,
            isExpand: false,
            expandIconPosition: EXPAND_ICON_POSITION.up
          });
          break;
        case isBuilderOpen && previousStatus === POPUP_STATUSES.maximize:
          this.setState({
            isBuilderOpen: false,
            expandIconPosition: EXPAND_ICON_POSITION.down
          });
          break;
        case previousStatus === POPUP_STATUSES.minimize:
          this.setState({
            previousStatus: POPUP_STATUSES.maximize,
            isExpand: true,
            expandIconPosition: EXPAND_ICON_POSITION.down
          });
          break;
        case previousStatus === POPUP_STATUSES.maximize:
          this.setState({
            previousStatus: POPUP_STATUSES.minimize,
            isExpand: false,
            expandIconPosition: EXPAND_ICON_POSITION.up
          });
          break;
        default:
          break;
      }
    });
    _defineProperty(this, "openProductBuilder", product => {
      const {
        previousStatus
      } = this.state;
      this.props.openRelatedProductBuilder(product);
      this.setState({
        isBuilderOpen: true,
        chosenProduct: product,
        isExpand: true,
        expandIconPosition: previousStatus === POPUP_STATUSES.maximize ? EXPAND_ICON_POSITION.left : EXPAND_ICON_POSITION.down
      });
    });
    _defineProperty(this, "onCloseHandler", () => {
      this.props.onClose();
      setTimeout(() => this.setState(initialState), TRANSITION_TIME);
    });
    this.state = initialState;
  }
  render() {
    const {
      open,
      relatedProducts,
      popupMode
    } = this.props;
    const {
      isExpand,
      isBuilderOpen,
      expandIconPosition
    } = this.state;
    return /*#__PURE__*/React.createElement(Drawer, {
      open: open,
      onClose: this.onCloseHandler,
      anchor: "bottom",
      headerTitle: isBuilderOpen ? 'Choose colors and select quantity' : 'Add Products',
      containerClassName: classes.drawer,
      transitionTime: TRANSITION_TIME,
      paperClassName: cn(classes.paper, {
        [classes.height100]: isExpand || isBuilderOpen
      }),
      headerClassName: classes.header,
      closeClassName: classes.closeButton,
      bodyClassName: cn(classes.body, {
        [classes.height90vh]: isExpand || isBuilderOpen,
        [classes.overflowHidden]: !isExpand
      }),
      isButtonDisabled: true,
      dataDrawer: "RelationProductDrawer",
      isLoading: false,
      isButtonShown: false,
      isExpandable: true,
      isExpandButtonShown: popupMode === PRODUCT_BUILDER_MODES.BUILD_MODE && (relatedProducts.length > 6 || isExpand),
      expandIconPosition: expandIconPosition,
      onButtonClick: this.expandClickHandler,
      closeButtonStyle: closeButtonStyles,
      MiddleBlock: /*#__PURE__*/React.createElement(HeaderContent, {
        isExpand: isExpand
      })
    }, !isBuilderOpen && /*#__PURE__*/React.createElement(Products, {
      isExpand: isExpand,
      products: relatedProducts,
      openRelatedProductBuilder: this.openProductBuilder
    }), isBuilderOpen && /*#__PURE__*/React.createElement("div", {
      className: classes.productBuilder
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.emptyBlock
    }), /*#__PURE__*/React.createElement("div", {
      className: classes.productEditorWrapper
    }, /*#__PURE__*/React.createElement(ProductEditor, null), /*#__PURE__*/React.createElement(ProductPreviews, null)), /*#__PURE__*/React.createElement("div", {
      className: classes.detailsWrapper
    }, /*#__PURE__*/React.createElement(Details, {
      onCloseHandler: this.onCloseHandler
    }))));
  }
}